function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L19.9272 0L19.9272 20L0 20L0 0Z",
  id: "healthcare_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "healthcare_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#healthcare_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "apple-(2)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L19.9272 0L19.9272 20L0 20L0 0Z",
  id: "apple-(2)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#healthcare_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.8185502 4.78125)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8197 6.53632C13.7918 6.37699 13.6406 6.27062 13.4816 6.29851C13.3228 6.32652 13.2168 6.4784 13.2447 6.63781C13.5948 8.63722 15.0779 9.58676 15.704 9.90394C15.5353 10.3944 15.1529 11.3603 14.48 12.3463C13.7649 13.3958 12.9544 14.5853 11.7509 14.6082C10.5425 14.6282 10.1059 13.8356 8.55904 13.8356C7.01189 13.8356 6.5197 14.5865 5.37431 14.632C4.29614 14.6734 3.4313 13.5516 2.56723 12.2981C0.970523 9.98011 -0.295554 5.68613 1.35256 2.81504C2.04173 1.61453 3.18279 0.800622 4.48312 0.582028C4.64211 0.55531 4.74941 0.404255 4.72279 0.244645C4.69617 0.0850359 4.54578 -0.0227374 4.38663 0.00409855C2.91354 0.251755 1.62326 1.16968 0.846601 2.52254C-0.915048 5.59136 0.354531 10.1166 2.08699 12.6314C2.79985 13.6656 3.87067 15.2193 5.31916 15.2191C6.62506 15.2191 7.11549 14.4217 8.559 14.4216C9.96648 14.4216 10.3802 15.22 11.7618 15.194C13.2663 15.1654 14.2065 13.7857 14.9618 12.6772C15.675 11.6321 16.0796 10.6084 16.2572 10.0911C16.3512 9.81726 16.2279 9.51262 15.9704 9.3825C15.4254 9.10715 14.1248 8.27851 13.8197 6.53632Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(9.654176 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.83955 0.00683176C1.57077 0.354683 -0.0697948 2.55554 0.00228544 4.48804C0.0139226 4.79832 0.270173 5.04472 0.577176 5.04472C0.582625 5.04472 0.588074 5.04464 0.593523 5.04449C2.7165 4.98421 4.55436 2.77031 4.508 0.566636C4.50068 0.217027 4.18539 -0.0462932 3.83955 0.00683176ZM1.56571 1.92855C2.13897 1.25492 3.08683 0.715816 3.92447 0.586168C3.95946 2.44996 2.39962 4.40027 0.585466 4.45851C0.55145 3.47148 1.06843 2.50562 1.56571 1.92855Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.323824 4.6601562)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.52431 0.0103608C4.86619 -0.112842 3.45273 0.903407 2.79988 0.903407C2.26554 0.903407 1.34523 0.336337 0.350157 0.13329C0.192063 0.100947 0.0380551 0.203447 0.00590698 0.362002C-0.0262023 0.520556 0.0758082 0.675243 0.233786 0.707509C1.20757 0.906259 2.09184 1.48938 2.79988 1.48938C3.65114 1.48938 4.95478 0.481142 6.48104 0.594696C7.75151 0.689853 8.8558 1.16618 9.63494 2.15958C9.12801 2.5261 7.93163 3.56227 7.70426 5.30243C7.68332 5.46286 7.79592 5.60997 7.95573 5.63102C7.96861 5.6327 7.98141 5.63352 7.99406 5.63352C8.13838 5.63352 8.26382 5.5261 8.28316 5.37864C8.48127 3.86247 9.53476 2.95372 9.97845 2.63345C10.241 2.44399 10.3051 2.06759 10.0986 1.80333C9.21818 0.676962 7.96476 0.118173 6.52431 0.0103608Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgHealthcare = function SvgHealthcare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthcare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/healthcare.315c31b4.svg";
export { ForwardRef as ReactComponent };